const it = {
  common: {
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    close: "Chiudi",
    back: "Indietro",
    next: "Avanti",
    loading: "Caricamento...",
    saving: "Salvataggio...",
    confirm: "Conferma",
    yes: "Sì",
    no: "No",
    all: "Tutte",
    none: "Nessuno",
    error: "Errore",
    success: "Successo",
    refresh: "Aggiorna",
    logout: "Esci",
    dashboard: "Dashboard",
    settings: "Impostazioni",
    profile: "Profilo",
    today: "Oggi",
    noData: "Nessun dato",
    copied: "Copiato",
    required: "Obbligatorio",
    optional: "Opzionale",
    minutes: "minuti",
    search: "Cerca",
  },
  auth: {
    welcome: "Benvenuto",
    loginSubtitle: "Accedi al tuo account EVA AI",
    email: "Email",
    password: "Password",
    login: "Accedi",
    loggingIn: "Accesso in corso...",
    forgotPassword: "Password dimenticata?",
    forgotPasswordTitle: "Password Dimenticata?",
    forgotPasswordDesc: "Inserisci la tua email per ricevere il link di reset",
    enterEmail: "Inserisci la tua email",
    resetLinkSent: "Se l'email esiste, riceverai un link di reset",
    resetLinkSentLong: "Se l'email esiste nel nostro sistema, riceverai un link di reset entro pochi minuti. Controlla anche la cartella spam.",
    sendError: "Errore nell'invio",
    sending: "Invio in corso...",
    sendResetLink: "Invia Link Reset",
    backToLogin: "Torna al Login",
    setNewPassword: "Imposta Nuova Password",
    setNewPasswordDesc: "Inserisci la tua nuova password",
    passwordResetSuccess: "Password reimpostata con successo!",
    tokenInvalid: "Token non valido o scaduto",
    invalidLink: "Link non valido. Richiedi un nuovo link di reset.",
    requestNewLink: "Richiedi Nuovo Link",
    updating: "Aggiornamento...",
    noAccount: "Non hai un account?",
    signup: "Registrati",
    emailRequired: "Email e password sono obbligatori",
    loginSuccess: "Login effettuato con successo!",
    invalidCredentials: "Credenziali non valide",
    signupTitle: "Crea Account",
    signupSubtitle: "Registra il tuo account EVA AI",
    tenantName: "Nome Studio/Attività",
    confirmPassword: "Conferma Password",
    passwordMismatch: "Le password non corrispondono",
    passwordTooShort: "La password deve essere di almeno 8 caratteri",
    allFieldsRequired: "Tutti i campi sono obbligatori",
    signupSuccess: "Account creato con successo!",
    signingUp: "Registrazione...",
    hasAccount: "Hai già un account?",
    currentPassword: "Password Attuale",
    newPassword: "Nuova Password",
    confirmNewPassword: "Conferma Nuova Password",
    changePassword: "Aggiorna Password",
    changingPassword: "Aggiornamento...",
    passwordChanged: "Password aggiornata",
    minChars: "Minimo 8 caratteri",
    wrongCurrentPassword: "Password attuale non corretta",
    fillAllFields: "Compila tutti i campi",
  },
  verifyEmail: {
    title: "Verifica la tua email",
    checking: "Verifica dell'email in corso...",
    successTitle: "Email verificata",
    successDesc: "Il tuo indirizzo email è stato verificato correttamente.",
    invalidTitle: "Verifica non riuscita",
    invalidDesc: "Questo link di verifica non è valido o è scaduto. Puoi richiederne uno nuovo dalla dashboard.",
    missingToken: "Il token di verifica manca da questo link.",
    goToDashboard: "Vai alla dashboard",
    goToLogin: "Vai al login",
    bannerTitle: "Verifica la tua email",
    bannerDesc: "Verifica l'email per poter recuperare l'account e ricevere comunicazioni importanti sul servizio.",
    resend: "Invia di nuovo l'email",
    sending: "Invio...",
    sent: "Email di verifica inviata. Controlla la posta.",
    sendError: "Impossibile inviare l'email di verifica. Riprova più tardi.",
  },

  dashboard: {
    completeSetup: "Completa la Configurazione",
    activateSubscription: "Attiva l'abbonamento per utilizzare EVA AI.",
    configureWhatsApp: "Configura WhatsApp per iniziare a ricevere messaggi.",
    startSetup: "Inizia Setup",
    subscription: "Abbonamento",
    founderPlan: "Piano founder con accesso completo",
    monthlyActive: "99 CHF/mese - Attivo",
    setupRequired: "Configurazione richiesta",
    activateBtn: "Attiva Abbonamento",
    whatsapp: "WhatsApp",
    phoneNumber: "Numero",
    notSpecified: "Non specificato",
    notConfigured: "Nessuna configurazione presente",
    configure: "Configura",
    messages: "Messaggi",
    lastMessages: "Ultimi messaggi ricevuti",
    evaStatus: "Stato EVA",
    evaActive: "Eva Attiva",
    evaPaused: "Eva In Pausa",
    autoResponses: "Risposte automatiche",
    quickPause: "Pausa rapida",
    pausedFor: "Eva in pausa per {minutes} minuti",
    evaReactivated: "Eva riattivata",
    languageControl: "Controllo Lingua",
    languageControlDesc: "Imposta la lingua predefinita e forza per tutti i contatti",
    defaultLanguage: "Lingua Predefinita",
    forceLanguage: "Forza Lingua Globale",
    forceLanguageOn: "Tutti i contatti riceveranno risposte in questa lingua",
    forceLanguageOff: "Eva rileva automaticamente la lingua",
    saveLanguage: "Salva Controllo Lingua",
    languageSaved: "Controllo lingua salvato",
    quickActions: "Azioni Rapide",
    openInbox: "Apri Inbox",
    calendar: "Calendario",
    setupWizard: "Setup Wizard",
    refreshData: "Aggiorna Dati",
    recentMessages: "Messaggi Recenti",
    recentMessagesDesc: "Ultimi 10 messaggi ricevuti",
    noMessages: "Nessun messaggio ancora",
    noMessagesHint: "I messaggi appariranno qui quando inizi a ricevere richieste",
    contact: "Contatto",
    direction: "Direzione",
    message: "Messaggio",
    language: "Lingua",
    date: "Data",
    received: "Ricevuto",
    sent: "Inviato",
    subscriptionActivated: "Abbonamento attivato",
    checkoutReceived: "Checkout ricevuto, controllo in corso...",
    dataLoadError: "Errore nel caricamento dei dati",
    statusUpdateError: "Errore nell'aggiornamento dello stato",
    pauseError: "Errore nella pausa",
    languageSaveError: "Errore nel salvataggio",
    contactLanguageUpdated: "Lingua contatto aggiornata",
    contactLanguageError: "Errore nell'aggiornamento",
    active: "Attivo",
    pastDue: "Pagamento in Ritardo",
    canceled: "Cancellato",
    incomplete: "Incompleto",
    connected: "Connesso",
  },
  calendar: {
    title: "Calendario Appuntamenti",
    confirmed: "confermati",
    pending: "in attesa",
    blocked: "bloccati",
    arriving: "in arrivo",
    noAppointments: "Nessun appuntamento",
    noAppointmentsDay: "Nessun appuntamento per questo giorno",
    newAppointment: "Nuovo",
    blockSlot: "Blocca",
    girlFilter: "Ragazza",
    statusFilter: "Stato",
    allGirls: "Tutte",
    activeFilter: "Attivi",
    confirmedFilter: "Confermati",
    pendingFilter: "In attesa",
    blockedFilter: "Bloccati",
    completedFilter: "Completati",
    appointmentDetail: "Dettaglio Appuntamento",
    blockedSlot: "Slot Bloccato",
    girl: "Ragazza",
    dateLabel: "Data",
    time: "Orario",
    duration: "Durata",
    whatsappLabel: "WhatsApp",
    buzzer: "Campanello",
    notes: "Note",
    dateTime: "Data/Ora",
    status: "Stato",
    arrivalStatus: "Stato Arrivo",
    noChanges: "Nessuna modifica",
    appointmentUpdated: "Appuntamento aggiornato",
    deleted: "Eliminato",
    newAppointmentTitle: "Nuovo Appuntamento",
    girlRequired: "Ragazza e data/ora sono obbligatori",
    appointmentCreated: "Appuntamento creato",
    clientPhone: "WhatsApp cliente",
    languageOptional: "Lingua",
    buzzerOptional: "Campanello",
    createAppointment: "Crea Appuntamento",
    creating: "Creo...",
    blockSlotTitle: "Blocca Slot",
    blockDuration: "Durata",
    blockReason: "Motivo / Note",
    blockReasonPlaceholder: "Es: Pausa, indisponibile, ecc.",
    blockSubmit: "Blocca Slot",
    blocking: "Blocco...",
    slotBlocked: "Slot bloccato",
    loadError: "Errore nel caricamento appuntamenti",
    blocked_label: "BLOCCATO",
  },
  settings: {
    title: "EVA AI - Impostazioni",
    whatsappConfig: "Configurazione WhatsApp",
    whatsappConfigDesc: "Gestisci le credenziali WhatsApp Business API",
    webhookUrl: "URL Webhook",
    phoneNumberId: "Phone Number ID",
    accessToken: "Access Token",
    accessTokenStored: "Token salvato",
    accessTokenStoredHint: "Token salvato in modo sicuro. Non devi reinserirlo.",
    replaceAccessToken: "Sostituisci token",
    replaceAccessTokenHint: "Inserisci un nuovo token solo se vuoi sostituire quello salvato.",
    accessTokenRequiredHint: "Inserisci il token Meta. Dopo il salvataggio resterà memorizzato in modo sicuro.",
    verifyToken: "Verify Token",
    phoneNumber: "Numero Telefono",
    saveWhatsApp: "Salva Configurazione WhatsApp",
    whatsappSaved: "Configurazione WhatsApp salvata",
    generalSettings: "Impostazioni Generali",
    generalSettingsDesc: "Personalizza il comportamento di EVA AI",
    defaultLanguage: "Lingua Predefinita",
    forceLanguage: "Forza Lingua Globale",
    forceLanguageDesc: "Ignora rilevazione automatica e usa sempre questa lingua",
    forcedLanguage: "Lingua Forzata",
    durations: "Durate (minuti, separate da virgola)",
    externalDetailsLink: "Link Dettagli Esterni (compliance)",
    pricingText: "Testo Prezzi",
    rules: "Regole",
    locationInfo: "Informazioni Posizione",
    welcomeMessage: "Messaggio di Benvenuto",
    saveSettings: "Salva Impostazioni",
    settingsSaved: "Impostazioni salvate",
    studioConfig: "Configurazione Studio",
    studioConfigDesc: "Impostazioni pubbliche per info e prenotazioni",
    studioName: "Nome Studio",
    publicInfoUrl: "Link Ufficiale (Servizi/Prezzi/Ragazze)",
    publicInfoUrlWarning: "Senza un link valido (http:// o https://) EVA non può inviare il link per servizi/prezzi/ragazze. Risponderà comunque con tono dolce e guiderà alla prenotazione, ma senza condividere il link.",
    publicInfoUrlHint: "Questo link verrà usato per rispondere a richieste su servizi, prezzi e ragazze",
    girlsList: "Ragazze (una per riga)",
    girlsListHint: "Se più di una ragazza, EVA chiederà la scelta. Se una sola, selezione automatica.",
    saveStudio: "Salva Configurazione Studio",
    saveError: "Errore nel salvataggio",
    loadError: "Errore nel caricamento dei dati",
    urlCopied: "URL copiato",
  },
  wizard: {
    title: "Setup EVA AI",
    stepOf: "Passo {step} di {total}",
    billingTitle: "Abbonamento",
    billingDesc: "Attiva il tuo abbonamento mensile per usare EVA AI",
    founderTitle: "Piano Internal (Founder)",
    founderDesc: "Hai accesso completo a tutte le funzionalità senza abbonamento.",
    founderHint: "Puoi procedere direttamente alla configurazione di WhatsApp.",
    subscriptionActive: "Abbonamento attivo! Puoi procedere con la configurazione.",
    standardPlan: "Piano Standard",
    standardPlanDesc: "Tutto incluso, nessun vincolo",
    perMonth: "al mese",
    featureWhatsApp: "WhatsApp Cloud API integration",
    featureMultilang: "Supporto multilingua (IT/DE/EN/ES)",
    featureBooking: "FSM booking engine",
    featureDashboard: "Dashboard e analytics",
    activateSubscription: "Attiva Abbonamento",
    activating: "Apertura Checkout...",
    stripeRedirect: "Sarai reindirizzato a Stripe per completare il pagamento in modo sicuro.",
    privatePilotBilling: "EVA è in pilot privato: gli abbonamenti e gli addebiti sono disattivati finché il servizio non sarà aperto alla vendita.",
    privatePilotClosed: "Pagamenti chiusi durante il pilot",
    whatsappTitle: "Configurazione WhatsApp",
    whatsappDesc: "Collega il tuo account WhatsApp Business",
    webhookUrl: "URL Webhook",
    phoneNumberId: "Phone Number ID",
    phoneNumberIdHint: "Trovalo in Meta Business Manager → WhatsApp → API Setup",
    accessToken: "Access Token",
    verifyToken: "Verify Token",
    verifyTokenHint: "Usa questo valore fornito da EVA quando Meta chiede il Verify Token del webhook. È gestito da EVA.",
    phoneNumber: "Numero Telefono",
    fillRequired: "Compila tutti i campi obbligatori",
    whatsappSaved: "Configurazione WhatsApp salvata",
    settingsTitle: "Impostazioni",
    settingsDesc: "Personalizza il comportamento di EVA AI",
    defaultLanguage: "Lingua Predefinita",
    durations: "Durate Disponibili (minuti, separate da virgola)",
    externalDetailsLink: "Link Dettagli Esterni (IMPORTANTE per compliance)",
    externalDetailsHint: "EVA reindirizzerà a questo link quando riceve media o richieste esplicite",
    pricingText: "Testo Prezzi",
    rules: "Regole",
    locationInfo: "Informazioni Posizione",
    welcomeMessage: "Messaggio di Benvenuto",
    settingsSaved: "Impostazioni salvate",
    testTitle: "Test Messaggio",
    testDesc: "Invia un messaggio di test per verificare la configurazione",
    testAlmostDone: "Setup quasi completo! Invia un messaggio di test per confermare che tutto funzioni.",
    recipient: "Numero Destinatario (formato internazionale, senza +)",
    recipientHint: "Es: 41791234567 per un numero svizzero",
    messageLabel: "Messaggio",
    sendTest: "Invia Messaggio di Test",
    sending: "Invio in corso...",
    testSent: "Messaggio di test inviato con successo!",
    testCheckPhone: "Controlla il tuo telefono per verificare la ricezione del messaggio",
    fillRecipient: "Inserisci numero e messaggio",
    completeSetup: "Completa Setup",
    setupComplete: "Setup completato!",
    checkoutError: "Errore nell'apertura del checkout",
  },
  account: {
    title: "EVA AI - Profilo",
    subscription: "Abbonamento",
    subscriptionDesc: "Gestisci il tuo piano e abbonamento",
    plan: "Piano",
    status: "Stato",
    nextRenewal: "Prossimo rinnovo",
    scheduledCancel: "Disdetta programmata",
    cancelWarning: "L'abbonamento resterà attivo fino alla fine del periodo già pagato ({date}).",
    founderAlert: "Founder plan: accesso illimitato senza costi.",
    price: "Prezzo",
    validUntil: "Valido fino al",
    scheduledCancelAlert: "Disdetta programmata: L'abbonamento terminerà alla fine del periodo in corso.",
    cancelSubscription: "Disdici Abbonamento (Fine Periodo)",
    cancelConfirmTitle: "Confermi la disdetta?",
    cancelConfirmDesc: "La disdetta avrà effetto alla fine del periodo già pagato. Il mese in corso non è rimborsabile.",
    confirmCancel: "Conferma Disdetta",
    canceling: "Disdetta...",
    cancelSuccess: "Disdetta programmata",
    cancelError: "Errore nella disdetta",
    security: "Sicurezza",
    securityDesc: "Cambia la password del tuo account",
    active: "Attivo",
    pastDue: "Pagamento in Ritardo",
    canceledStatus: "Cancellato",
    incompleteStatus: "Incompleto",
    founderInternal: "Founder / Internal",
    standard: "Standard",
    yourData: "I tuoi dati",
    yourDataDesc: "Esporta i dati del tuo account o richiedi la cancellazione assistita",
    dataLifecycleNotice: "L'esportazione non include password, credenziali dei provider o dati delle carte. Le richieste di cancellazione vengono verificate e gestite senza promettere scadenze non dimostrate.",
    downloadData: "Scarica i miei dati",
    dataExportSuccess: "Esportazione dati pronta",
    dataExportError: "Impossibile esportare i dati",
    requestDeletion: "Richiedi cancellazione account",
    deletionConfirmTitle: "Richiedere la cancellazione?",
    deletionConfirmDesc: "La richiesta verrà registrata per la verifica operativa. Abbonamento, obblighi legali, fornitori terzi e backup devono essere gestiti prima della chiusura.",
    deletionConfirmationLabel: "Digita DELETE MY EVA ACCOUNT",
    submitDeletionRequest: "Invia richiesta",
    deletionRequestSuccess: "Richiesta di cancellazione registrata",
    deletionRequestError: "Impossibile registrare la richiesta",
  },
  inbox: {
    title: "EVA AI - Inbox",
    conversations: "Conversazioni",
    noConversations: "Nessuna conversazione",
    noConversationsHint: "Le conversazioni appariranno qui quando riceverai messaggi",
    messagesLabel: "messaggi",
    lastActivity: "ultima attività",
    typeMessage: "Scrivi un messaggio...",
    send: "Invia",
    selectConversation: "Seleziona una conversazione",
    selectConversationHint: "Scegli una conversazione dalla lista per vedere i messaggi",
    messageSent: "Messaggio inviato",
    messageSendError: "Errore nell'invio del messaggio",
    loadError: "Errore caricamento conversazioni",
    messagesLoadError: "Errore caricamento messaggi",
    eva: "EVA",
    client: "Cliente",
    manualMode: "Manuale",
    manualModeActive: "Modalità manuale attiva. Eva non risponderà automaticamente.",
    manualModeActivated: "Modalità manuale attivata",
    evaReactivated: "Eva riattivata",
    modeChangeError: "Errore cambio modalità",
    noMessages: "Nessun messaggio",
    active: "Attivo",
    optedOut: "Disattivato",
    now: "Ora",
    minutesAgo: "{n}m fa",
    hoursAgo: "{n}h fa",
    unreadNew: "nuovo",
    unreadNewPlural: "nuovi",
    contacts: "contatti",
    contact: "contatto",
  },
  languages: {
    it: "Italiano",
    de: "Tedesco",
    en: "Inglese",
    es: "Spagnolo",
    auto: "Auto",
  },
  signup: {
    title: "Crea il Tuo Account",
    subtitle: "Inizia a usare EVA AI in pochi minuti",
    button: "Crea Account",
    creating: "Creazione in corso...",
    termsAccept: "Creando un account accetti i nostri",
    termsOfService: "Termini di Servizio",
    and: "e la",
    privacyPolicy: "Privacy Policy",
    legalConsentPrefix: 'Accetto i',
    legalConsentAndPrivacy: 'e confermo di aver letto la',
    legalRequired: "Per creare l'account devi accettare i Termini e il DPA e confermare di aver letto la Privacy Policy.",
    legalUnavailable: 'Le informazioni legali non sono disponibili. Ricarica la pagina prima di registrarti.',
    nonCommercialLegal: 'Questo ambiente non è ancora configurato per uso commerciale: i dati legali sono incompleti.',
    privatePilotTitle: "Pilot privato su invito",
    privatePilotDesc: "Le nuove registrazioni e i pagamenti sono temporaneamente chiusi. Gli utenti già invitati possono continuare ad accedere e testare EVA.",
    privatePilotLogin: "Accedi al pilot",
  },
  uiLanguage: {
    label: "Lingua interfaccia",
    selectorTitle: "Lingua",
  },
  landing: {
    login: "Accedi",
    startNow: "Inizia ora",
    heroTitle1: "L'assistente WhatsApp",
    heroTitle2: "per le prenotazioni del tuo studio",
    heroSubtitle: "Automatizza prenotazioni, richieste clienti e gestione appuntamenti via WhatsApp con EVA AI. Multilingua, conforme e pronta in pochi minuti.",
    heroCta: "Inizia ora",
    learnMore: "Scopri di più",
    featuresTitle: "Funzionalità principali",
    featuresSubtitle: "Tutto ciò che ti serve per gestire prenotazioni e richieste clienti via WhatsApp",
    feature1Title: "Automazione WhatsApp",
    feature1Desc: "Assistente automatico per prenotazioni e richieste clienti via WhatsApp.",
    feature2Title: "Supporto multilingua",
    feature2Desc: "Italiano, tedesco, inglese e spagnolo con gestione coerente della lingua.",
    feature3Title: "Motore prenotazioni intelligente",
    feature3Desc: "Comprende richieste naturali e gestisce prenotazioni con data, ora e durata in modo affidabile.",
    feature4Title: "Compliance integrata",
    feature4Desc: "Gestione STOP/START, media redirect e controllo dei contenuti sensibili.",
    pricingTitle: "Prezzo semplice e chiaro",
    pricingSubtitle: "Un solo piano, tutto incluso",
    planName: "Piano Standard",
    planPeriod: "al mese, nessun vincolo",
    bullet1: "Integrazione WhatsApp Cloud API",
    bullet2: "Supporto multilingua (IT/DE/EN/ES)",
    bullet3: "Motore prenotazioni intelligente",
    bullet4: "Dashboard e statistiche",
    bullet5: "Conformità GDPR/FADP",
    privacy: "Privacy",
    terms: "Termini",
    dpa: "DPA",
  },
  alerts: {
    bookingCreated: "Nuova Prenotazione",
    bookingUpdated: "Prenotazione Modificata",
    bookingCancelled: "Prenotazione Cancellata",
    customerArrival: "Cliente in Arrivo",
    manualModeMessage: "Messaggio (EVA off)",
    girl: "Ragazza",
    time: "Orario",
    duration: "Durata",
    client: "Cliente",
    source: "Fonte",
    whatsapp: "WhatsApp",
    manual: "Manuale",
    changed: "Modificato",
    unknown: "Sconosciuto",
    phone: "Telefono",
    arrivalHelp: "Assistenza arrivo",
    soundOn: "Suono alert ON",
    soundOff: "Suono alert OFF",
    noAlerts: "Nessun alert recente",
    recentAlerts: "Alert Recenti",
    clearAll: "Pulisci tutto",
    dismiss: "Rimuovi",
    viewCalendar: "Calendario",
    viewInbox: "Inbox",
    min: "min",
    arrivalIncoming: "in arrivo",
    arrivalOutside: "sul posto",
    arrivalAtDoor: "alla porta",
    arrivalArrived: "arrivato",
  },
};

export default it;
